import { render, staticRenderFns } from "./Side-Reports-Basic-Group.vue?vue&type=template&id=11d2149b"
import script from "./Side-Reports-Basic-Group.vue?vue&type=script&lang=js"
export * from "./Side-Reports-Basic-Group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports